/**
 * Takes the height of the language row (EN FR AR ES) that `TranslatableInput`
 * shows between its label and its field, with the same classes, so a plain
 * input placed beside a translatable one lines up with it.
 */
export function LangRowSpacer() {
  return (
    <div aria-hidden className="invisible mb-1 flex">
      <span className="border-b-2 px-2.5 py-0.5 text-[11px]">EN</span>
    </div>
  );
}
